import type { AiContextLibrary } from "@redotech/redo-marketing-ai-common/ai-context-library";
import { AiContextLibrarySchema } from "@redotech/redo-marketing-ai-common/ai-context-library";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getContextLibraryItemById = {
  name: "getContextLibraryItemById" as const,
  input: z.object({ itemId: zExt.objectId() }),
  output: AiContextLibrarySchema as z.ZodType<AiContextLibrary>,
};
